import { wait } from "../lib/helpers";

export function usePopUp() {
  function PopUp(pu) {
    if (!(pu instanceof Element)) {
      return;
    }

    const closeBtn = pu.querySelector(".btn--close");
    const alwaysOn = pu.dataset.always === "true";
    const prevID = localStorage.getItem("redapron-pop-up");
    const btns = pu.querySelectorAll('[class*="btn"]');

    function saveID() {
      localStorage.setItem("redapron-pop-up", pu.id);
    }

    function open() {
      pu.classList.add("open");
    }

    async function close() {
      pu.classList.remove("open");
      await wait(300);
      pu.remove();
    }

    btns.forEach((btn) => btn.addEventListener("click", saveID));
    closeBtn.addEventListener("click", close);
    pu.addEventListener("click", (e) => {
      if (e.currentTarget === e.target) {
        saveID();
        close();
      }
    });

    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        saveID();
        close();
      }
    });

    if (alwaysOn || prevID !== pu.id) {
      open();
    } else {
      pu.remove();
    }
  }

  const pu = document.querySelector(".pop-up--overlay");

  PopUp(pu);
}
